export default "https://cdn-static.gokick.com/assets/27898be65df9afd7cb19e5714fb6a6df6232ba84/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";